import React, { useEffect, useRef, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { FormikCheckbox, FormikSelectInput, FormikTextInput } from 'components/UI/Inputs/FormikInputs';
import { Form, Formik } from 'formik';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { rowSelected, secondaryModalData, snackbarData, userCredentials } from 'recoilState/GlobalState';
import { RequestServiceActions } from 'services/services-mia/RequestServiceActions';
import XGridDemo from 'components/UI/Grid/XGrid';
import { inviteParticipants as titles } from 'consts/titulos-de-tablas';
import { FormButton } from 'components';
import classes from '../index.module.scss';

const tiposDeFirmas = [
    { name: "Digital", id: 1, value: "D" },
    { name: "Olografa", id: 2, value: "O" }
]

export default function FormSignerInt({ formData, roles, signers, participants, updateList }) {
    const [userSigner, setUserSigner] = useState([]);
    const [secondaryXgridRowSelected, setSecondaryXgridRowSelected] = useState();
    const formikRef = useRef();

    const credentials = useRecoilValue(userCredentials);
    const xgridRowSelected = useRecoilValue(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const setSecondaryModalData = useSetRecoilState(secondaryModalData);

    useEffect(() => {
        if (secondaryXgridRowSelected?.row) {
            setUserSigner([secondaryXgridRowSelected.row]);
            formikRef?.current?.setFieldValue('mail', secondaryXgridRowSelected.row.mail || '');
        }
    }, [secondaryXgridRowSelected]);

    const participantsByRole = participants.filter((e) => e.rol === "Firmante Interno");
    const hasExistingSigners = participantsByRole.length > 0;
    const signersHaveOrden = participantsByRole.some((p) => p.orden != null && p.orden !== '');

    const handleSubmit = async (values) => {
        if (userSigner.length) {
            const promises = userSigner.map(async (signer) => {
                const body = {
                    service: "SBMDocumentoUsuarioIns",
                    params: {
                        sbmDocumentoId: xgridRowSelected.row.id,
                        usuarioId: signer.usuarioId,
                        rolId: Number(formData.roles),
                        tipoDeDocumentoId: signer.tipoDocumentoId,
                        tipoDeDocumentoCod: signer.tipoDeDocumentoCod,
                        usuarioNroDeDocumentoX: signer.usuarioNroDocumentoX,
                        usuarioMail: values.mail,
                        sbmDocumentoUsuarioTieneOrden: values.orden ? "Y" : "N",
                        sbmDocumentoUsuarioTag: null,
                        sbmDocumentoUsuarioTipoFirma: values.tipoFirma,
                        usuarioNombres: signer.usuarioNombres,
                        usuarioApellidos: signer.usuarioApellidos
                    }
                };
                return RequestServiceActions(body, credentials, null, setSnackbarInfo);
            });
            await Promise.all(promises);
            await updateList();
            setSecondaryModalData({ isOpen: false });
        }
    };

    return (
        <Formik
            initialValues={{
                orden: hasExistingSigners ? signersHaveOrden : false,
                tipoFirma: xgridRowSelected.row.sbmDocumentoTipoFirma === "O" ? "O" : "D",
            }}
            innerRef={formikRef}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            <Form>
                <Grid container columnSpacing={3}>
                    <Grid item lg={6}>
                        <FormikTextInput name={"mail"} placeholder={"example@hotmail.com"} labelText={"Email"} />
                    </Grid>
                    <Grid item lg={6}>
                        <FormikSelectInput
                            name={"tipoFirma"}
                            id={"tipoFirma"}
                            labelText={"Tipo de firma"}
                            disabled={xgridRowSelected.row.sbmDocumentoTipoFirma !== "H"}
                        >
                            {tiposDeFirmas.map((tipoFirma) => (
                                <option value={tipoFirma.value} key={tipoFirma.id}>{tipoFirma.name}</option>
                            ))}
                        </FormikSelectInput>
                    </Grid>
                    <Grid item lg={6} display="flex" alignItems="center">
                        <FormikCheckbox labelText={"Firmas en orden de ingreso"} name={"orden"} disabled={hasExistingSigners} />
                    </Grid>
                    <Grid item lg={12} display={"flex"}>
                        <Typography variant='h1' style={{ fontSize: "15px" }}>
                            {`Selecciona los firmantes:`}
                        </Typography>
                        <Typography variant='h1' style={{ fontSize: "15px" }} ml={1}>
                            <span className={classes.round}>{xgridRowSelected.row.firmantesInternos}</span> firmantes restantes
                        </Typography>
                    </Grid>
                    <Grid item lg={12} height={"40vh"}>
                        <XGridDemo
                            titles={titles}
                            rows={signers}
                            secondarySelected={secondaryXgridRowSelected}
                            setSecondarySelected={setSecondaryXgridRowSelected}
                        />
                    </Grid>
                    <Grid item lg={12}>
                        <FormButton
                            newFormData={{ button: "Invitar" }}
                            disableAutoClose
                            onCloseModal={() => setSecondaryModalData({ isOpen: false })}
                        />
                    </Grid>
                </Grid>
            </Form>
        </Formik>
    );
}
